import { Link } from "react-router-dom";
import type { Manga } from "@/mocks/manga";

export default function MangaCard({ manga }: { manga: Manga }) {
  return (
    <Link
      to={`/article/${manga.slug}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-shadow hover:border-primary-200"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-100">
        <img
          src={manga.cover}
          alt={`${manga.title} 漫画封面`}
          title={`${manga.title} 漫画 免费阅读`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-background-950/70 px-2 py-1 text-xs text-background-50 backdrop-blur">
          {manga.status}
        </span>
        {manga.isHot && (
          <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-1 text-xs font-medium text-background-50">
            <i className="ri-fire-fill"></i>热
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background-950/80 to-transparent p-2.5 pt-6">
          <p className="truncate text-xs text-background-50">{manga.latestChapter}</p>
        </div>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-600">
          {manga.title}
        </h3>
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500"></i>
            {manga.rating.toFixed(1)}
          </span>
          <span>{manga.chapters}话</span>
        </div>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {manga.tags.slice(0, 2).map((t) => (
            <span key={t} className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
              {t}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}